import { getRouterSlotsByTypes, getAvailableRouterSlotsByType } from './manageRouterSlots';
import { IBudgetSlot } from '../types/store/budget';
import { IRouterSlot, IRouterSlotFront } from '../types/store/routerData';

// GS calc
export const getMaxGs = (acceptedSlotsTypes: string[], slotsRouter: IRouterSlot[]) =>
  getRouterSlotsByTypes(slotsRouter, acceptedSlotsTypes).reduce(
    (accumulator, slot) => accumulator + (slot as IRouterSlotFront).gs,
    0
  );

export const getAvailableGs = (acceptedSlotsTypes: string[], slotsRouter: IRouterSlot[], budgetSlots: IBudgetSlot[]) =>
  getAvailableRouterSlotsByType(slotsRouter, budgetSlots, acceptedSlotsTypes).reduce(
    (accumulator, slot) => accumulator + (slot as IRouterSlotFront).gs,
    0
  );



// WEBPACK FOOTER //
// ./src/utils/manageGs.ts